import React, { Fragment } from 'react'
import Configuration from '../utils/configuration';

import {Link} from 'react-router-dom';

export default function PartForm(props) {
    let part = props.part;
    let g_recaptcha_key = Configuration.googleCaptchaSite;
    return (
        <Fragment>
            <div className="text" id={`div_${part['form_config']['form_id'] ? part['form_config']['form_id'] : ''}`}>
                <div dangerouslySetInnerHTML={{__html: part['content']}} />
            </div>

            <form className="form" method="post" action={`${Configuration.URL_FORM}lib/form/suscribe`} enctype="multipart/form-data" id={part['form_config']['form_id'] ? part['form_config']['form_id']:''}>
                <div className="form-columns">
                    <div className="form-column">
                        {
                            part['form_config']['fields'].map(data => {
                                if (data['type'] !== 'textarea') {
                                    var required = data['required'] ? 'required': '';
                                    switch (data['type']) {
                                        case 'select':
                                            return (
                                                <div className="form-block">
                                                    <label for={data['name']}><strong>{data['label']}</strong></label>
                                                    <select name={data['name']} {...required}>
                                                    {
                                                        data['aux_data']['options'].map(option => {
                                                            var def ='';
                                                            if (option['value'] === data['value']) {
                                                                def = 'selected';
                                                            }
                                                            return <option value={option['value']} {...def}>{option['text']}</option>
                                                        })
                                                    }
                                                    </select>
                                                </div>
                                            )
                                        case 'checkbox':
                                            return (
                                                <div className="form-block">
                                                    <div>
                                                        <input type="checkbox" name={data['name']} {...required} />{data['label']}
                                                    </div>
                                                </div>
                                            )
                                        case 'multiple':
                                            return (
                                                <div className="form-block">
                                                    <label for={data['name']}><strong>{data['label']}</strong></label>
                                                    <div className="options">
                                                    {
                                                        data['aux_data']['options'].map(option => (
                                                            <div className="option">
                                                                {
                                                                    data['aux_data']['radio_type'] ==='checkbox' ?
                                                                        <Fragment>
                                                                            <input type={data['aux_data']['radio_type']} name={`${data['name']}[]`} value={option['value']} {...required} />{option['text']}
                                                                        </Fragment>
                                                                    :
                                                                        <Fragment>
                                                                            <input type={data['aux_data']['radio_type']} name={`${data['name']}`} value={option['value']} {...required} />{option['text']}
                                                                        </Fragment>
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                    </div>
                                                </div>
                                            )
                                        case 'file':
                                            return (
                                                <div className="form-block big">
                                                    <label for={data['name']}><strong>{data['label']}</strong></label>
                                                    <input type="file" name={data['name']} placeholder={data['placeholder']} {...required} />
                                                </div>
                                            )

                                        case 'hidden':
                                            return (
                                                <div className="form-block">
                                                    <input type={data['type']} name={data['name']} value={data['value']} {...required} />
                                                </div> 
                                            )
                                        default:
                                            return (
                                                <Fragment>
                                                    {
                                                        data['name'] === 'email' ?
                                                            <div className="form-block big">
                                                                <label for={data['name']}><strong>{data['label']}</strong></label>
                                                                <input type={data['type']} name={data['name']} placeholder={data['placeholder']} {...required} />
                                                            </div>
                                                        :
                                                            <div className="form-block">
                                                                <label for={data['name']}><strong>{data['label']}</strong></label>
                                                                <input type={data['type']} name={data['name']} placeholder={data['placeholder']} {...required} />
                                                            </div>
                                                    }
                                                </Fragment>
                                            )
                                    }
                                    
                                } else if(data['type'] === 'textarea'){
                                    return (
                                        <div className="form-block big">
                                            <label for={data['name']}><strong>{data['label']}</strong></label>
                                            <textarea name={data['name']} rows="12" placeholder={data['placeholder']} {...required}></textarea>
                                        </div>
                                    )
                                } else {
                                    return null
                                }
                            })
                        }
                    </div>
                    
                </div>
                <div className="form-block legal">
                    <div className="flex fl-align-center">
                        <input type="checkbox" name="legal" required />
                        <p>Acepto los términos y condiciones del <Link to="/aviso-legal">aviso legal</Link>.</p>
                    </div>
                    <input type="hidden" name="form_id" value={part['form_config']['form_id']} />

                </div>
                <div className="form-bottom">
                    <div className="g-recaptcha" data-sitekey={g_recaptcha_key}></div>

                    <div className="part-button">
                        <input className="button input" type="submit" value="Enviar" />
                    </div>
                </div>
            </form>
        </Fragment>
    )
}